import React from 'react';
import { Box, Text, VStack, Flex, useColorModeValue } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6 }
  }
};

export const Feature = ({ title, text, icon, delay = 0 }) => {
  return (
    <MotionBox
      variants={itemVariants}
      initial="hidden"
      animate="visible"
      transition={{ delay }}
      p={6}
      bg={useColorModeValue('white', 'gray.800')}
      rounded={'xl'}
      shadow={'lg'}
      height="100%"
      minH="320px"
      display="flex"
      flexDirection="column"
      _hover={{
        transform: 'translateY(-5px)',
        transition: 'all 0.2s ease-in-out',
      }}
    >
      <Flex
        w={16}
        h={16}
        align={'center'}
        justify={'center'}
        color={'white'}
        rounded={'full'}
        bg={'blue.500'}
        mb={4}
      >
        {icon}
      </Flex>
      <Text
        fontWeight={600}
        fontSize={'xl'}
        mb={4}
      >
        {title}
      </Text>
      <Text
        color={useColorModeValue('gray.600', 'gray.400')}
        flex={1}
      >
        {text}
      </Text>
    </MotionBox>
  );
};
